module.exports = __webpack_public_path__ + "img/red-2-diamond-solid.5d90aec2.svg";